import { AdjustmentStatus } from "../enums/adjustment-status.enum";

const STATUS_TRANSLATE: Record<AdjustmentStatus, string> = {
    [AdjustmentStatus.OPEN]: 'Creado',
    [AdjustmentStatus.CREATED]: 'Creado',
    [AdjustmentStatus.APPROVED]: 'Aprobado',
    [AdjustmentStatus.REJECTED]: 'Rechazado',
};


export class AdjustmentHelper {

    static getStatusTranslation(status){
        return STATUS_TRANSLATE[status]
    }
}